import { mutate } from 'swr';

export const WORKFLOW_EXECUTION_BASE_URL = 'workflow-execution';

export const invalidateWorkflowExecution = (workflowExecutionId: string) => {
  mutate(`${WORKFLOW_EXECUTION_BASE_URL}/${workflowExecutionId}`);
};
